import { type BaseItem } from '../common.js';
import {
  type CreateValues as PhoneNumberCapabilityCreateValues,
  type PhoneNumberCapabilityPopulated,
} from './phoneNumberCapability.js';
import { type CreateValues as VendorPhoneNumberCreateValues } from './vendorPhoneNumber.js';

export enum PhoneNumberType {
  Pstn = 'Pstn',
  Sip = 'Sip',
}

export enum PhoneNumberFunction {
  InboundVoiceTrigger = 'InboundVoiceTrigger',
  OutboundVoiceCallWithAssistant = 'OutboundVoiceCallWithAssistant',
  OutboundSMSMessage = 'OutboundSMSMessage',
  InboundSMSConversation = 'InboundSMSConversation',
}

interface BasePhoneNumberConfiguration {
  phoneNumber: string;
  displayName: string;
  type: PhoneNumberType;
  sipPracticeRoutingEnabled: boolean;
  organizationId: string | null;
  deletedTimestamp: string | null;
  sourceVendorAccountId: string | null;
}

export type PhoneNumberConfiguration = BasePhoneNumberConfiguration & BaseItem;

export type UpdateValues = Partial<
  Pick<
    BasePhoneNumberConfiguration,
    'displayName' | 'sipPracticeRoutingEnabled' | 'organizationId' | 'sourceVendorAccountId'
  >
>;

export interface CreateValues {
  phoneNumber: string;
  displayName: string;
  type?: PhoneNumberType;
  sipPracticeRoutingEnabled?: boolean;
  organizationId: string | null;
  sourceVendorAccountId?: string | null;
  vendorPhoneNumbers?: Omit<VendorPhoneNumberCreateValues, 'phoneNumberId'>[];
  capabilities?: Omit<PhoneNumberCapabilityCreateValues, 'phoneNumberId'>[];
}

export interface PhoneNumberConfigurationPopulated extends PhoneNumberConfiguration {
  capabilities: PhoneNumberCapabilityPopulated[];
  supportedFunctions: PhoneNumberFunction[];
}

export type FindAllOptions = Partial<Omit<BasePhoneNumberConfiguration, 'organizationId'>> & {
  organizationIds?: string[];
  includeShared?: boolean;
  includeDeleted?: boolean;
  supportedFunctions?: PhoneNumberFunction[];
};
